var portfolio = {
	addTransactionAction: "Ajouter une Transaction",
	topFlopTitle: "Position Top/Flop",
	breakdownsTitle: "Composition du portefeuille",
	assetClassBreakdownTitle: "Classes d'actifs",
	currencyBreakdownTitle: "Devises",
	sectorBreakdownTitle: "Secteurs",
	sectorBreakdownSubtitle: "Pondération par rapport au portefeuille total",
	evaluationChartTitle: "Valeur du portefeuille",
	unrealizedPerformancePositionsTitle: "Performance non réalisée",
	weightPositionsTitle: "Pondération du portefeuille",
	editPortfolioAction: "Modifier le Portefeuille",
	deletePortfolioAction: "Supprimer le Portefeuille",
	createPortfolioAction: "Créer le Portefeuille",
	addPortfolioAction: "Create portfolio",
	editTransactionAction: "Modifier la Transaction",
	deleteTransactionAction: "Supprimer la Transaction",
	errorAlertLabel: "Une erreur s'est produite",
	transactionLimitExceeded: "Limite de transaction dépassée",
	portfolioLimitExceeded: "Limite du portefeuille dépassée",
	info: "Info",
	noPositionsAlert: "Le portefeuille ne contient aucune position, veuillez ajouter une transaction d'achat",
	noTransactionsAlert: "Le portefeuille ne contient pas de transactions, veuillez ajouter une transaction d'achat",
	noPortfolios: {
		title: "Info",
		message: "Aucun portefeuille n'a encore été créé. Veuillez cliquer sur le bouton \"Ajouter un Portefeuille\" et remplir le formulaire pour créer un portefeuille."
	},
	tab: {
		overview: "Overview",
		positions: "Positions",
		transactions: "Transactions",
		news: "Actualités"
	},
	showActions: "Afficher les actions"
};
var fr = {
	portfolio: portfolio
};

export { fr as default, portfolio };
